import React, { useState, useEffect, useRef } from 'react';
import './QuickChat.css';

const EMOTES = ['😊', '😂', '😮', '😢', '😡', '👍', '👎', '🔥', '👏', '🤝', '⌛', '❓'];
const PHRASES = [
  'Good luck!',
  'Nice move!',
  'GG!',
  'Wait...',
  'Thanks!',
  'Sorry',
  'Thinking...',
  'Rematch?',
  'Mistake!',
  'Well played'
];

export default function QuickChat({ socket, roomId, meId, gameType = 'chess' }) {
  const [isOpen, setIsOpen] = useState(false);
  const [incoming, setIncoming] = useState(null);
  const timeoutRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (!socket) return;

    const handleEmote = (data) => {
      // data: { userId, emote }
      if (Number(data.userId) === Number(meId)) return;
      
      setIncoming(data.emote);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setIncoming(null);
      }, 4000);
    };

    socket.on('game:emote:received', handleEmote);
    return () => {
      socket.off('game:emote:received', handleEmote);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [socket, meId]);

  const sendEmote = (emote) => {
    if (!socket || !roomId) return;
    socket.emit('game:emote', { roomId, matchId: roomId, emote, gameType });
    setIsOpen(false);
    
    setIncoming(emote);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setIncoming(null);
    }, 4000);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div className="quick-chat-container">
      {/* Incoming Message Bubble */}
      {incoming && (
        <div className="quick-chat-bubble-mount">
          <div className="quick-chat-bubble animate-pop-in">
            {incoming}
          </div>
        </div>
      )}

      {/* Launcher Button */}
      <button 
        className={`quick-chat-trigger ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        title="Quick Chat"
      >
        <span className="trigger-icon">💬</span>
      </button>

      {/* Overlay Menu */}
      {isOpen && (
        <div className="quick-chat-menu animate-slide-up" ref={menuRef}>
          <div className="quick-chat-sections">
            <div className="quick-chat-section">
              <div className="section-title">Emotes</div>
              <div className="emotes-grid">
                {EMOTES.map((e, i) => (
                  <button key={i} className="emote-btn" onClick={() => sendEmote(e)}>
                    {e}
                  </button>
                ))}
              </div>
            </div>
            
            <div className="quick-chat-divider" />
            
            <div className="quick-chat-section">
              <div className="section-title">Phrases</div>
              <div className="phrases-list">
                {PHRASES.map((p, i) => (
                  <button key={i} className="phrase-btn" onClick={() => sendEmote(p)}>
                    {p}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
